import React, { Component } from 'react';
import Navbar from './components/Navbar/Navbar.js';
import NavbarMobile from './components/Navbar/Mobile/NavbarMobile.js';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Briefing from './routes/Briefing.js';
import Business from './routes/Business.js';
import Settings from './routes/Settings/Settings.js';
import YourAccount from './routes/Settings/YourAccount/YourAccount.js';
import GiftSubscriptions from './routes/Settings/GiftSubscriptions/GiftSubscriptions.js';
import PersonalInformation from './routes/Settings/YourAccount/PersonalInformation.js';
import PaymentDetails from './routes/Settings/YourAccount/PaymentDetails.js';
import Subscription from './routes/Settings/YourAccount/Subscription.js';
import About from './routes/About.js';
import Elements from './routes/Elements.js';
import './App.scss';
import Homepage from './pages/Homepage.js';

class App extends Component {

  constructor(props) {
    super(props)

    this.state = {
      appIsActive: true,
      homeIsActive: false,
    }
  }

  componentDidMount() {
    window.addEventListener('load', this.handlePathChange);
    window.addEventListener('popstate', this.handlePathChange)
    window.addEventListener('click', this.handlePathChange)
  }

  handlePathChange = (event) => {

    const pathName = window.location.pathname

    if (pathName === '/') {
      this.setState({ appIsActive: true, homeIsActive: false })
    }
    if (pathName === '/home') {
      this.setState({ appIsActive: false, homeIsActive: true })
    }
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path='/home' component={Homepage} />
        </Switch>
        <div className={ this.state.appIsActive === true ? "d-block" : "d-none" }>
          <NavbarMobile />
          <div className="App d-flex">
            <div className="col_left d-none d-lg-block">
              <Navbar />
            </div>
            <div className="col_right">
              <div className="maxWidth-800 m-auto">
                <Switch>
                  <Route exact path='/' component={Briefing} />
                  <Route path='/business' component={Business} />
                  <Route exact path='/settings' component={Settings} />
                  <Route path='/about' component={About} />
                  <Route path='/elements' component={Elements} />
                  <Route path='/settings/account' component={YourAccount} />
                  <Route path='/settings/gift-subscriptions' component={GiftSubscriptions} />
                  <Route path='/settings/subscription' component={Subscription} />
                  <Route path='/settings/payment-details' component={PaymentDetails} />
                  <Route path='/settings/personal-information' component={PersonalInformation} />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
